import {AppRoutePathFunction} from '../logic/routes';
import AnalyticsBadgePath from '../media/analytics_badge.svg';
import EncodingBadgePath from '../media/encoding_badge.svg';
import AboutUsSvg from '../media/hexagonIconImage/icons/about_us.svg';
import AnalyticsSvg from '../media/hexagonIconImage/icons/analytics.svg';
import EncodingSvg from '../media/hexagonIconImage/icons/encoding.svg';
import LiveEncodingSvg from '../media/hexagonIconImage/icons/live-encoding.svg';
import PlayerSvg from '../media/hexagonIconImage/icons/player.svg';
import PlayerBadgePath from '../media/player_badge.svg';

export enum Product {
  CloudAnalytics,
  Encoding,
  OnPremiseAnalytics,
  OnPremiseEncoding,
  Player,
  Playback,
  LiveEncoding,
  StreamLab
}

export const ProductToText = {
  [Product.CloudAnalytics]: 'Analytics',
  [Product.OnPremiseAnalytics]: 'On-Premise Analytics',
  [Product.Encoding]: 'Encoding',
  [Product.LiveEncoding]: 'Live Encoding',
  [Product.OnPremiseEncoding]: 'On-Premise Encoding',
  [Product.Player]: 'Player',
  [Product.Playback]: 'Playback',
  [Product.StreamLab]: 'Stream Lab'
};

export const ProductToAppRoutePath = {
  [Product.CloudAnalytics]: AppRoutePathFunction.CloudAnalytics(),
  [Product.OnPremiseAnalytics]: AppRoutePathFunction.OnPremiseAnalytics(),
  [Product.Encoding]: AppRoutePathFunction.Encoding(),
  [Product.LiveEncoding]: AppRoutePathFunction.LiveEncoding(),
  [Product.OnPremiseEncoding]: AppRoutePathFunction.OnPremiseEncoding(),
  [Product.Player]: AppRoutePathFunction.Player(),
  [Product.Playback]: AppRoutePathFunction.Playback()
};

export const ProductToHexagonIconSrc = {
  [Product.CloudAnalytics]: AnalyticsSvg,
  [Product.OnPremiseAnalytics]: AnalyticsSvg,
  [Product.Encoding]: EncodingSvg,
  [Product.LiveEncoding]: LiveEncodingSvg,
  [Product.OnPremiseEncoding]: EncodingSvg,
  [Product.Player]: PlayerSvg,
  [Product.Playback]: PlayerSvg,
  [Product.StreamLab]: AboutUsSvg
};

export const ProductToBadgeSrc = {
  [Product.CloudAnalytics]: AnalyticsBadgePath,
  [Product.OnPremiseAnalytics]: AnalyticsBadgePath,
  [Product.Encoding]: EncodingBadgePath,
  [Product.LiveEncoding]: EncodingBadgePath,
  [Product.OnPremiseEncoding]: EncodingBadgePath,
  [Product.Player]: PlayerBadgePath,
  [Product.Playback]: PlayerBadgePath,
  [Product.StreamLab]: PlayerBadgePath
};
